<!-- div class="identicon--wrapper size-{{size}} {{type}}" #icon></div -->
<div class="avatar size-{{ size }}">
  <div class="image">
    <div class="identicon--wrapper {{ type }}" #icon></div>
  </div>
</div>
